module.exports = __webpack_public_path__ + "static/media/IMG_4407-min.7c144f99.JPG";